<div
  class="action-sheet-shell"
  [class.action-sheet-shell--full]="mobileState() === 'full'"
  [class.action-sheet-shell--dragging]="isDragging()"
  [style.--action-sheet-width]="config().width"
  [style.transform]="dragOffset() ? 'translateY(' + dragOffset() + 'px)' : null"
  [clickOutsideCancelEvent]="true"
  (clickOutside)="onClickOutside()"
  data-testid="action-sheet"
>
  <div
    class="drag-handle"
    data-testid="action-sheet-drag-handle"
    (pointerdown)="onDragStart($event)"
    (pointermove)="onDragMove($event)"
    (pointerup)="onDragEnd()"
    (pointercancel)="onDragEnd()"
  ></div>
  <router-outlet (activate)="onOutletActivate($event)" (deactivate)="onOutletDeactivate()" />
</div>
